import React from "react";
import {
  Image,
  Linking,
  ScrollView,
  StyleSheet,
  TouchableNativeFeedback,
  TouchableOpacity,
  View,
} from "react-native";
import Text from "@components/CustomText";
import colors from "@constants/color";
import { normalize } from "@constants/metrics";
import testIds from "@constants/testIds";
import t from "@constants/localization";
import { fontFamily } from "@utils/styles";
import OrderStatus from "../../../assets/svg/OrderStatus";
import StarChecked from "../../../assets/svg/StarChecked";
import { RatingMapping } from "../../../components/RateOrderScreen";

// const { width } = Dimensions.get("window");
export const showLimitedImages = (imgs = [], limit = 3) => {
  if (!imgs.length || limit <= 0) {
    return;
  }
  const totalImages = imgs.length;
  const toShowOnlyArr = imgs.slice(0, limit);
  return (
    <>
      {toShowOnlyArr.map((imageUrl, imageIndex) => (
        <Image
          resizeMode="contain"
          key={imageUrl}
          source={{ uri: imageUrl }}
          style={styles.image}
        />
      ))}
      {toShowOnlyArr.length < totalImages && (
        <View style={styles.nMoreBox}>
          <Text variant="body_text_4" style={{ color: "rgba(0,0,0,0.56)" }}>
            +{+totalImages - limit}
          </Text>
        </View>
      )}
    </>
  );
};

const CommissionTag = ({ received }) => {
  if (received) {
    return (
      <View style={styles.commissionTag}>
        <OrderStatus
          orderStatus="OrderSuccessful"
          style={{ margin: 2 }}
          height={14}
          width={14}
        />
        <Text style={[styles.commissionTagText, { color: "#00AB59" }]}>
          {t("OrderList/orderCard/commission")}
        </Text>
      </View>
    );
  } else {
    return (
      <View style={styles.commissionTag}>
        <OrderStatus
          orderStatus="OrderCancelled"
          style={{ margin: 2 }}
          height={14}
          width={14}
        />
        <Text style={[styles.commissionTagText, { color: "#FF2E00" }]}>
          {t("OrderList/orderCard/commission")}
        </Text>
      </View>
    );
  }
};

const OrderCard = (props) => {
  const {
    item = {},
    navigateToDetails = () => {},
    navigateToRating = () => {},
    onWaShare = () => {},
    showUserName = true,
    showPhone = true,
    index,
  } = props;
  const {
    order_id = "",
    created_at = "",
    num_items = 1,
    num_quantity = 1,
    images = [],
    user_name = "",
    user_phone = "",
    payable_amount = "",
    payment_mode = "",
    order_status = "",
    order_status_icon = "",
    order_status_color = "",
    user_address = "",
    share_message = "",
    order_rating = null,
    order_level = 0,
    is_delivered_by_cmo: isDeliveredByCMO = false,
    is_commission_received: isCommissionReceived = true,
  } = item;

  const shouldAskForRating = order_level === 4;

  return (
    <TouchableNativeFeedback
      testID={`${testIds.order_no}${index}`}
      onPress={() => navigateToDetails(order_id, "FORWARD")}
      background={TouchableNativeFeedback.Ripple("rgba(0, 0, 0, 0.05)")}
    >
      <View
        style={[
          styles.orderCardContainer,
          { borderRadius: showUserName ? 0 : 10, paddingBottom: 15 },
        ]}
      >
        <View style={styles.topContainer}>
          <View style={styles.orderIdContainer}>
            <Text
              style={{
                fontSize: normalize(14),
                color: colors.lightBlack,
                fontFamily: "NotoSansDevanagari-Regular",
              }}
            >
              {t("OrderList/orderCard/orderNo")}
              <Text
                style={{
                  fontFamily: fontFamily.bold,
                  color: colors.black,
                  fontSize: normalize(14),
                }}
              >{`${order_id}`}</Text>
            </Text>
            <View
              style={{
                margin: 0,
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontSize: normalize(12),
                  color: colors.lightBlack,
                  fontFamily: "NotoSansDevanagari-Regular",
                }}
              >
                {num_items} {t("OrderList/orderCard/items")} • {num_quantity}{" "}
                {t("OrderList/orderCard/qty")}
              </Text>
            </View>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "flex-end",
              flex: 0.5,
              flexWrap: "wrap",
            }}
          >
            <Text
              style={{
                fontSize: normalize(14),
                color: colors.lightBlack,
                fontFamily: "NotoSansDevanagari-Regular",
              }}
            >
              {t("OrderList/orderCard/orderDate")}
            </Text>
            <Text
              style={{
                color: colors.black,
                fontSize: normalize(14),
                fontFamily: fontFamily.bold,
              }}
            >
              {` ${created_at.trim()}`}
            </Text>
          </View>
        </View>

        <ScrollView horizontal contentContainerStyle={styles.imageContainer}>
          {images && showLimitedImages(images, 4)}
        </ScrollView>
        {showUserName && (
          <View style={styles.namePriceContainer}>
            <Text style={styles.namePriceText}>{user_name}</Text>
            <Text
              style={[
                styles.namePriceText,
                { fontFamily: "NotoSansDevanagari-Bold" },
              ]}
            >
              {payable_amount > 0 ? `₹${parseInt(payable_amount, 10)}` : ""}
            </Text>
          </View>
        )}

        {showPhone && (
          <View style={styles.phonePaymentContainer}>
            <TouchableOpacity
              testID="oc-phone-button"
              onPress={() =>
                Linking.openURL(`whatsapp://send?phone=+91${user_phone}`)
              }
            >
              <View>
                <Text
                  style={{
                    color: colors.lightBlack,
                    fontSize: 12,
                    lineHeight: 16,
                    fontFamily: "NotoSansDevanagari-Regular",
                  }}
                >
                  +91 - {user_phone}
                </Text>
              </View>
            </TouchableOpacity>
            <View>
              <Text
                style={{
                  color: "rgba(0, 0, 0, 0.56)",
                  fontFamily: "NotoSansDevanagari-Regular",
                  fontSize: 12,
                  lineHeight: 16,
                }}
              >
                {+payable_amount > 0 ? payment_mode : ""}
              </Text>
            </View>
          </View>
        )}

        <View style={styles.deliveryContainer}>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <OrderStatus
              orderStatus={order_status_icon}
              style={{ marginRight: 6 }}
            />
            <Text
              style={{
                color: order_status_color,
                fontFamily: "NotoSansDevanagari-SemiBold",
                marginTop: 6,
              }}
            >
              {order_status}
            </Text>
            {isDeliveredByCMO && (
              <View
                style={{
                  flexDirection: "row",
                  marginHorizontal: 6,
                  marginTop: 4,
                  alignItems: "center",
                }}
              >
                <Text style={styles.deliveredByCMO}>
                  {t("OrderList/orderCard/deliveredByCMO")}
                </Text>
                <CommissionTag received={isCommissionReceived} />
              </View>
            )}
          </View>
        </View>

        {user_address && (
          <View style={{ width: "90%", flexDirection: "row" }}>
            <Text
              style={{
                lineHeight: 16,
                fontSize: 12,
                fontFamily: "Mulish",
                color: "rgba(0, 0, 0, 0.56)",
                textTransform: "capitalize",
              }}
            >
              {user_address}
            </Text>
          </View>
        )}
        <View style={styles.buttonsContainer}>
          {shouldAskForRating && (
            <TouchableOpacity
              testID="oc-rate-button"
              activeOpacity={order_rating === null ? 0.7 : 1}
              style={[
                styles.waContainer,
                {
                  flexDirection: "row",
                  backgroundColor: "white",
                  paddingHorizontal: 15,
                  borderWidth: order_rating === null ? 1 : 0,
                  color:
                    order_rating === null
                      ? colors.darkBackground
                      : colors.white,
                },
              ]}
              onPress={() => {
                if (order_rating === null) {
                  navigateToRating({
                    for_order: true,
                    order_id,
                    // refresh: () => {
                    //   fetchCommunityLeaderOrders(false);
                    // },
                    rating_cl: order_rating
                      ? Number(order_rating.slice(0, 1))
                      : 0,
                    review_cl: order_rating
                      ? order_rating.map((x) => Number(x))
                      : [],
                    // expected_commission,
                    // delivered_at,
                  });
                }
              }}
            >
              {order_rating !== null ? (
                <View>
                  <Text
                    style={{
                      color: colors.lightBlack,
                      flex: 1,
                      textAlign: "left",
                      fontFamily: "NotoSansDevanagari-Regular",
                      fontSize: 12,
                    }}
                  >
                    {t("OrderList/orderCard/givenRating")}
                  </Text>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: -3,
                    }}
                  >
                    <StarChecked size={16} />
                    <Text
                      style={{
                        color: colors.lightBlack,
                        marginLeft: 6,
                        fontFamily: "NotoSansDevanagari-Bold",
                        fontSize: 14,
                        paddingTop: 5,
                      }}
                    >
                      {order_rating.slice(0, 1)}
                    </Text>
                    <View
                      style={{
                        width: 1,
                        height: 16,
                        backgroundColor: colors.lightBlack,
                        marginHorizontal: 10,
                      }}
                    />
                    <Text
                      style={{
                        color: colors.lightBlack,
                        fontFamily: "NotoSansDevanagari-Bold",
                        fontSize: 12,
                        paddingTop: 5,
                      }}
                    >
                      {RatingMapping[order_rating.slice(0, 1)]}
                    </Text>
                  </View>
                </View>
              ) : (
                <Text
                  style={{
                    color: "black",
                    marginLeft: 10,
                    fontSize: 14,
                    fontFamily: "NotoSansDevanagari-Bold",
                  }}
                >
                  {t("OrderList/orderCard/rateOrder")}
                </Text>
              )}
            </TouchableOpacity>
          )}
        </View>
      </View>
    </TouchableNativeFeedback>
  );
};

const styles = StyleSheet.create({
  orderCardContainer: {
    // backgroundColor: "red",
    flexDirection: "column",
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginVertical: 5,
    backgroundColor: colors.white,
  },
  orderIdContainer: {
    flex: 0.5,
    // flexDirection: "row",
    // alignItems: "center",
  },
  topContainer: {
    // backgroundColor: "pink",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  imageContainer: {
    overflow: "visible",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    paddingTop: normalize(12),
    paddingBottom: normalize(17),
  },
  image: {
    marginRight: 15,
    height: 50,
    width: 50,
    borderWidth: 1,
    borderColor: colors.lighterBlack,
  },
  nMoreBox: {
    height: 80,
    alignItems: "center",
    justifyContent: "center",
  },
  namePriceContainer: {
    // backgroundColor: "teal",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  namePriceText: {
    fontSize: normalize(16),
    fontFamily: "NotoSansDevanagari-SemiBold",
    color: colors.mediumBlack,
  },
  phonePaymentContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  deliveryContainer: {
    flex: 1,
    paddingBottom: 2,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  buttonsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 15,
  },
  waContainer: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: colors.mediumBlack,
    paddingVertical: 8,
    alignItems: "center",
    justifyContent: "center",
  },
  deliveredByCMO: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    fontWeight: "400",
    lineHeight: 24,
    textAlign: "left",
    color: colors.primary,
  },
  commissionTag: {
    flexDirection: "row",
    backgroundColor: "background: rgba(0, 0, 0, 0.06)",
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 1,
    paddingRight: 6,
    marginHorizontal: 4,
  },
  commissionTagText: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 12,
    fontWeight: "600",
    lineHeight: 18,
  },
});

export default OrderCard;
